import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {goalsList_template} from "../components/templates/goalsList_template";

declare var ko: any;
declare var page: any;

export class goals extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlListData: XMLHttpRequestHandler;
    protected goalsList: goalsList_template;

    protected getModuleName(){

        return "goals";
    }

    buildContent() : Array<Element>{

        // create the goals list
        this.goalsList = new goalsList_template("goals", this.viewModel, this);

        return [this.goalsList.build()];
    }

    public fillPage() : void{

        this.getListFormData()
    }

    /**
     *
     * @param id
     * @protected
     */
    protected viewGoal(id){
        page.redirect('/goals/view/'+id);
    }

    /**
     *
     * @param id
     * @protected
     */
    protected editGoal(id){
        page.redirect('/goals/edit/'+id);
    }


    protected addGoal(): void {

        page.redirect('/goals/edit');
    }

    protected getListFormData(): void {

        this.loadingIn(this.goalsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/goals/references/';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getListData();
                }
            });
        }
    }

    protected updateFilters(responseParsed: any): void {

        this.goalsList.setBrandsFilterItems(responseParsed.brands);
        this.goalsList.setInitiativesFilterItems(responseParsed.initiatives);
        this.goalsList.setGroupsFilterItems(responseParsed.groups);
        this.goalsList.setMonthsFilterItems(responseParsed.months);

        this.loadingOut(this.goalsList.builtTemplate.children.namedItem("list-results"));
    }


    public getListData(): void {

        this.loadingIn(this.goalsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdlListData ){

            this.XHRHdlListData.cancelAndReset();
        }

        let subViewModel = this.goalsList.getViewModelForRequest();
        //console.log(subViewModel);

        let usrReq_url: string = '/api/goals/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlListData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlListData.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdlListData.execute();

    }

    /**
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

                obj.loadingOut(obj.goalsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected paginationOnPageClick(){

        this.getListData();
    }

    protected goalsListReorder(){

        this.getListData();
    }

    protected filterSimpleOnChange(){

        // on keywords filtering, always set the page back to 1.
        this.goalsList.pagination.getTemplateViewModel().pageNumber(1);
        this.getListData();
    }

    protected filterDropdownOnChange() {

        this.getListData();
    }


    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        this.goalsList.setGoals(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.goalsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.goalsList.setPaginationTotalCount(responseParsed.totalCount);
    }

    public filterSimpleCancel(): void {
        console.log('filterSimpleCancel');
    }
}



// WEBPACK FOOTER //
// ./js/modules/goals.ts